<template>
  <div>
    <q-input
      v-model="name"
      debounce="600"
      placeholder="Search law firms..."
      class="q-mx-md"
      borderless
      autofocus
    >
      <template v-slot:prepend>
        <q-icon name="fa fa-search" style="font-size: 1.25rem" />
      </template>
    </q-input>
    <loader :task="task" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin } from '@/mixins';
import Loader from '@/components/loading/AsyncLinearProgress.vue';
import { Account, AccountFilters } from '../types';
import accountRepository from './account-repository';
import { AccountType } from '.';

interface Data {
  name: string,
}

export default defineComponent({
  emits: ['cleared', 'loaded'],
  mixins: [HasTaskMixin],
  components: { Loader },
  data(): Data {
    return {
      name: '',
    };
  },
  watch: {
    name(name: string): void {
      if (name === '') {
        this.$emit('cleared');
      } else {
        this.search();
      }
    },
  },
  methods: {
    search(): void {
      if (this.name === '') return;
      const filters:AccountFilters = { type: AccountType.CUSTOMER, name: this.name };
      this.task = accountRepository.findAll(filters);
      this.task.then((accounts: Account[]) => {
        this.$emit('loaded', accounts);
      });
    },
  },
});
</script>
